module.exports = {
  "country": "SE",
  "artist": "Carola",
  "song": "Främling",
  "year": "1983",
  "place": "3",
  "spotify": "17zFOtbuquEAAxSttpfWWl"
};